(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-page-header"] && !Shopify.designMode) return;
  try {
    
  let imageBlob;

  (async function () {
    imageBlob = await (await fetch(
      document.querySelector('#brand-image').src
    )).blob();
  })();

  defineEventListener('share', async event => {
    try {
      await navigator.share({
        files: [
          new File([imageBlob], 'image.png', {
            type: imageBlob.type,
          }),
        ],
        title: `Sustai Brands | ${document.title}`,
        url: document.URL,
      });

      console.log('Share successful');
    } catch (err) {
      console.error('Share failed:');
      console.dir(err);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-page-menu"] && !Shopify.designMode) return;
  try {
    
  const fragmentToElement = {};
  let selectedButton;

  defineEventListener('brandPage.handleMenuButtonClick', async (idFragment, menuButton) => {
    let element = fragmentToElement[idFragment];

    if (!element) {
      element = document.querySelector(`[id*="${idFragment}"]`);

      if (!element) {
        throw new Error(`No element with id fragment "${idFragment}" exists.`)
      }

      fragmentToElement[idFragment] = element;
    }

    element.scrollIntoView({ behavior: 'smooth' });
    selectedButton?.removeAttribute('aria-selected');
    menuButton.setAttribute('aria-selected', 'true');
    selectedButton = menuButton;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-blog-article"] && !Shopify.designMode) return;
  try {
    
  let imageBlob;

  (async function () {
    imageBlob = await (await fetch(
      document.querySelector('#article-image').src
    )).blob();
  })();

  defineEventListener('share', async event => {
    try {
      await navigator.share({
        files: [
          new File([imageBlob], 'image.png', {
            type: imageBlob.type,
          }),
        ],
        title: `Sustai Blog | ${document.title}`,
        url: document.URL,
      });

      console.log('Share successful');
    } catch (err) {
      console.error('Share failed:');
      console.dir(err);
    }
  });

  Array.from(
    document.querySelectorAll('.article a')
  ).forEach(anchor => {
    anchor.setAttribute('target', '_blank');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  defineEventListener('get15Button', () => {
    document.querySelector(
      '[title="Smile.io Rewards Program Launcher"]',
    ).contentDocument.body.querySelector(
      'button'
    ).click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-account"]) return;
  try {
    
const addressNames = document.querySelectorAll('.address-name');
addressNames.forEach((addressName, index) => {
  const addressTooltip = document.querySelectorAll('.address-tooltip')[index];

  addressName.addEventListener('mouseover', function() {
    addressTooltip.classList.remove('tw-hidden');
  });

  addressName.addEventListener('mouseleave', function() {
    addressTooltip.classList.add('tw-hidden');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.order-line-item-btn');

  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const orderLineItem = this.closest('.order-line-item');

      if (orderLineItem) {
        orderLineItem.classList.toggle('tw-max-h-[268px]');

        // Add or remove tw-relative and tw-h-auto classes on the parent container
        const orderGradientBox = orderLineItem.querySelector('.order-line-item-gradient');
        if (orderGradientBox) {
          orderGradientBox.classList.toggle('tw-relative');
          orderGradientBox.classList.toggle('tw-h-auto');
          orderGradientBox.classList.toggle('tw-pb-0');
        }

        // Get the product count from data-count attribute
        const productCount = this.getAttribute('data-count');

        // Update button text based on the current state
        if (orderLineItem.classList.contains('tw-max-h-[268px]')) {
          this.textContent = `See All ${productCount} Products`;
        } else {
          this.textContent = 'Show Less';
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-addresses"]) return;
  try {
    
  document.querySelectorAll('.settings-tab-btn').forEach(function(e){
    e.addEventListener('click', function(event){
        if(!event.target.classList.contains('tw-border')){
          let dataName = e.dataset.name
          document.querySelectorAll('.settings-tab-btn').forEach(function(e){
            e.classList.remove('tw-border-b', 'tw-border-b-2', 'tw-border-primary-1')
            e.classList.remove('tw-font-semibold');
            e.classList.add('tw-opacity-60')
            e.classList.add('tw-font-medium')
          })
          event.target.classList.add('tw-border-b', 'tw-border-b-2', 'tw-border-primary-1')
          event.target.classList.remove('tw-opacity-60');
          event.target.classList.remove('tw-font-medium');
          event.target.classList.add('tw-font-semibold');
          document.querySelectorAll('.settings-tab-content').forEach(function(content){
            if(content.dataset.name == dataName){
              content.classList.remove('tw-hidden')
              content.classList.add('tw-grid')
            }else{
              content.classList.add('tw-hidden')
              content.classList.remove('tw-grid')
            }
          })

        }
    })
})

let deleteAddress = document.querySelectorAll('.address-delete-btn');

if(deleteAddress){
  deleteAddress.forEach(function(e){
    e.addEventListener('click', function(url){
      let dataRemoveUrl = url.target.dataset.url;
      console.log(url)
      document.querySelector('#address-remove').action = dataRemoveUrl;
    })
  })
}

  document.querySelectorAll('.address-submit-btn').forEach(function(button) {
    const form = button.closest('form');
    if (!form) return;

    const container = form.querySelector('.address-form-container');
    if (!container) return;

    const inputs = container.querySelectorAll('input[required]');

    function validateInput(input) {
        const inputContainer = input.closest('.form-field') || input.parentElement;
        const errorMsg = inputContainer.querySelector('.err-msg');

        if (!input.value.trim()) {
            inputContainer.classList.add('error');
            if (errorMsg) errorMsg.classList.remove('tw-hidden');
            return false;
        } else if (input.classList.contains('input-phone')) {
            const phoneRegex = /^\+?[\d\s()-]{10,20}$/;
            if (!phoneRegex.test(input.value.trim())) {
                inputContainer.classList.add('error');
                if (errorMsg) errorMsg.classList.remove('tw-hidden');
                return false;
            }
        }

        inputContainer.classList.remove('error');
        if (errorMsg) errorMsg.classList.add('tw-hidden');
        return true;
    }

    function updateButtonState() {
        const allValid = Array.from(inputs).every(input => input.value.trim() !== '');
        button.disabled = !allValid;
        button.classList.toggle('tw-opacity-40', !allValid);
        button.classList.toggle('tw-cursor-not-allowed', !allValid);
    }

    inputs.forEach(function(input) {
        input.addEventListener('input', function() {
            validateInput(input);
            updateButtonState();
        });

        input.addEventListener('blur', function() {
            validateInput(input);
            updateButtonState();
        });
    });

    updateButtonState(); // İlk yükleme için buton durumunu ayarla

    button.addEventListener('click', function(event) {
        event.preventDefault();
        const formValid = Array.from(inputs).every(validateInput);
        if (formValid) {
            form.submit();
        } else {
            updateButtonState();
        }
    });
});

document.querySelectorAll('.drawer-close-button').forEach(function(button) {
    button.addEventListener('click', function() {
        const drawer = button.closest('.drawer');
        if (!drawer) return;

        const form = drawer.querySelector('form');
        if (!form) return;

        form.reset();
        form.querySelectorAll('.form-field.error').forEach(function(element) {
            element.classList.remove('error');
        });
        form.querySelectorAll('.err-msg').forEach(function(element) {
            element.classList.add('tw-hidden');
        });
        const submitButton = form.querySelector('.address-submit-btn');
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('tw-opacity-40', 'tw-cursor-not-allowed');
        }
    });
});

window.addEventListener('load', function() {
  const isAddress = localStorage.getItem('address') === 'true';

  if (isAddress) {
      showAddress();
  } else {
      showAccount();
  }
});

document.querySelector('.settings-tab-btn--address').addEventListener('click', function() {
  localStorage.setItem('address', 'true');
  showAddress();
});


document.querySelector('.settings-tab-btn--customer').addEventListener('click', function() {
  localStorage.setItem('address', 'false');
  showAccount();
});


function showAddress() {
  const addressDiv = document.querySelector('div[data-name="address"]');
  addressDiv.classList.remove('tw-hidden');
  addressDiv.classList.add('tw-grid');

  const accountDiv = document.querySelector('div[data-name="account"]');
  accountDiv.classList.remove('tw-grid');
  accountDiv.classList.add('tw-hidden');

  // Buton class güncellemeleri
  const addressBtn = document.querySelector('.settings-tab-btn--address');
  addressBtn.classList.add('tw-border-b', 'tw-border-b-2', 'tw-border-primary-1', 'tw-font-semibold');
  addressBtn.classList.remove('tw-font-medium', 'tw-opacity-60');

  const customerBtn = document.querySelector('.settings-tab-btn--customer');
  customerBtn.classList.remove('tw-border-b', 'tw-border-b-2', 'tw-border-primary-1', 'tw-font-semibold');
  customerBtn.classList.add('tw-font-medium', 'tw-opacity-60');
}


function showAccount() {
  const accountDiv = document.querySelector('div[data-name="account"]');
  accountDiv.classList.remove('tw-hidden');
  accountDiv.classList.add('tw-grid');

  const addressDiv = document.querySelector('div[data-name="address"]');
  addressDiv.classList.remove('tw-grid');
  addressDiv.classList.add('tw-hidden');

  const customerBtn = document.querySelector('.settings-tab-btn--customer');
  customerBtn.classList.add('tw-border-b', 'tw-border-b-2', 'tw-border-primary-1', 'tw-font-semibold');
  customerBtn.classList.remove('tw-font-medium', 'tw-opacity-60');

  const addressBtn = document.querySelector('.settings-tab-btn--address');
  addressBtn.classList.remove('tw-border-b', 'tw-border-b-2', 'tw-border-primary-1', 'tw-font-semibold');
  addressBtn.classList.add('tw-font-medium');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  defineEventListener('searchContent', event => {
    event.target.closest('form').querySelector(
      'input[name=type]'
    ).value = 'article';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar"]) return;
  try {
    
function nextStep(step) {
  document.querySelectorAll('.form-step').forEach(function (element) {
    element.classList.remove('active');
  });
  document.getElementById('step-' + step).classList.add('active');
}

defineEventListener('sellOnFloraSidebar.prevStep', function prevStep(step) {
  document.querySelectorAll('.form-step').forEach(function (element) {
    element.classList.remove('active');
  });
  document.getElementById('step-' + step).classList.add('active');
});

defineEventListener('sellOnFloraSidebar.handleOtherOptionSelect', function handleOtherOptionSelect() {
  const inputContainer = document.getElementById('otherPlatformInputContainer');
  inputContainer.style.display = 'block';
});

defineEventListener('sellOnFloraSidebar.selectOption', function selectOption(option, selectedElementId) {
  const selectedElement = document.getElementById(selectedElementId);
  selectedElement.textContent = option;

  selectedElement.classList.add('selected-option-title');

  const customSelect = selectedElement.closest('.custom-select');
  const dropdown = customSelect.querySelector('.select-items');
  const selectSelected = dropdown.previousElementSibling;

  if (option !== 'Other') {
    const inputContainer = customSelect.querySelector('.input-container');
    inputContainer.style.display = 'none';
  }
});

function validateCurrentStep(step) {
  const currentStep = document.getElementById('step-' + step);
  if (!currentStep) {
    return false;
  }

  const inputs = currentStep.querySelectorAll('input, select');
  let isValid = true;

  for (let input of inputs) {
    const inputContainer = input.closest('.input-container');

    if (inputContainer) {
      if (!input.checkValidity()) {
        input.style.borderColor = '#BB2727';
        showErrorMessage(inputContainer, 'Please ' + input.placeholder.toLowerCase() + ".");
        isValid = false;
      } else {
        input.style.borderColor = '';
        clearErrorMessage(inputContainer);
      }
    }
  }

  const customSelects = currentStep.querySelectorAll('.custom-select');

  if (customSelects.length > 0) {
    for (let customSelect of customSelects) {
      const checkboxes = customSelect.querySelectorAll('input[type="checkbox"]');
      if (checkboxes.length > 0) {
        const isAnyCheckboxChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
        const selectContainer = customSelect.querySelector('.select-selected');

        if (!isAnyCheckboxChecked) {
          selectContainer.style.borderColor = '#BB2727';
          showDropdownErrorMessage(selectContainer, 'This field is required to proceed.');
          isValid = false;
        } else {
          selectContainer.style.borderColor = '';
          clearErrorMessage(customSelect);
        }

        const otherCheckbox = customSelect.querySelector('input[type="checkbox"][value="other"]');
        const otherInput = customSelect.querySelector('.input-container input');
        if (otherCheckbox && otherCheckbox.checked) {
          if (!otherInput || otherInput.value.trim() === '') {
            showErrorMessage(otherInput.closest('.input-container'), 'Please fill out the input for the "Other" option.');
            otherInput.style.borderColor = '#BB2727';
            otherInput.focus();
            isValid = false;
          } else {
            otherInput.style.borderColor = '';
            clearErrorMessage(otherInput.closest('.input-container'));
          }
        }
      }

      const radioButtons = customSelect.querySelectorAll('input[type="radio"]');
      if (radioButtons.length > 0) {
        const isAnyRadioChecked = Array.from(radioButtons).some(radio => radio.checked);
        const selectContainer = customSelect.querySelector('.select-selected');

        if (!isAnyRadioChecked) {
          selectContainer.style.borderColor = '#BB2727';
          showDropdownErrorMessage(selectContainer, 'This field is required to proceed.');
          isValid = false;
        } else {
          selectContainer.style.borderColor = '';
          clearErrorMessage(customSelect);
        }

        const otherRadio = customSelect.querySelector('input[type="radio"][value="Other"]');
        if (otherRadio && otherRadio.checked) {
          const otherInput = customSelect.querySelector('#otherPlatformInput');
          if (!otherInput || otherInput.value.trim() === '') {
            showErrorMessage(otherInput.closest('.input-container'), 'Please fill out the input for the "Other" option.');
            otherInput.style.borderColor = '#BB2727';
            otherInput.focus();
            isValid = false;
          } else {
            otherInput.style.borderColor = '';
            clearErrorMessage(otherInput.closest('.input-container'));
          }
        }
      }
    }
  } else {
    console.error('No custom select found within the current step.');
  }

  const agreementCheckbox = currentStep.querySelector('#agreement');
  if (agreementCheckbox) {
    const checkboxContainer = agreementCheckbox.closest('.checkbox-container');
    if (!agreementCheckbox.checked) {
      checkboxContainer.style.borderColor = '#BB2727';
      showErrorMessage(checkboxContainer, 'You must acknowledge the agreement to proceed.');
      isValid = false;
    } else {
      checkboxContainer.style.borderColor = '';
      clearErrorMessage(checkboxContainer);
    }
  }

  return isValid;
}


function showErrorMessage(container, message) {
  let errorMessage = container.querySelector('.error-message');
  if (!errorMessage) {
    errorMessage = document.createElement('div');
    errorMessage.className = 'error-message';
    errorMessage.style = "color: #BB2727;padding-left: 24px;padding-top: 4px;font-weight: 500;font-size: 12px;";
    errorMessage.textContent = message;
    container.appendChild(errorMessage);
  } else {
    errorMessage.textContent = message;
  }
}

function showDropdownErrorMessage(container, message) {
  let errorMessage = container.nextElementSibling; // Look for the next sibling element after the container
  if (!errorMessage || !errorMessage.classList.contains('error-message')) {
    errorMessage = document.createElement('div');
    errorMessage.className = 'error-message';
    errorMessage.style = "color: #BB2727;padding-left: 24px;margin-top: -8px;font-weight: 500;font-size: 12px;";
    errorMessage.textContent = message;
    container.insertAdjacentElement('afterend', errorMessage); // Insert the error message after the container
  } else {
    errorMessage.textContent = message;
  }
}

function clearErrorMessage(container) {
  const errorMessage = container.querySelector('.error-message');
  if (errorMessage) {
    container.removeChild(errorMessage);
  }
}

function submitPartialForm(step) {
  const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSf0vQOX5iJayR6YOE4omyv5_UfC1gTCG3bgOV7BaAaLWEHyNg/formResponse';

  const formData = new FormData();

  if (step === 1) {
    formData.append('entry.602890204', document.getElementById('email').value); // Email
    formData.append('entry.2134345269', document.getElementById('website').value); // Website
  } else if (step === 2) {
    formData.append('entry.602890204', document.getElementById('email').value); // Email
    formData.append('entry.2134345269', document.getElementById('website').value); // Website
    formData.append('entry.557896437', document.getElementById('brandName').value); // Brand Name
    formData.append('entry.1186567875', document.getElementById('instagram').value); // Instagram Account
    formData.append('entry.1551851196', document.getElementById('contactName').value); // Contact Name
    formData.append('entry.1394358925', document.getElementById('contactPhone').value); // Contact Phone
  }

  fetch(googleFormUrl, {
    method: 'POST',
    body: formData,
    mode: 'no-cors'
  })
    .then(() => {
      console.log(`Form data for step ${step} submitted successfully.`);

    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

defineEventListener('sellOnFloraSidebar.validateAndProceed', function validateAndProceed(event) {
  const nextStepNumber = event.currentTarget.getAttribute('data-step');
  if (validateCurrentStep(nextStepNumber - 1)) {
    submitPartialForm(nextStepNumber - 1);
    nextStep(nextStepNumber);
  }
});

defineEventListener('sellOnFloraSidebar.closeSellOnFloraSideBar', function closeSellOnFloraSideBar() {
  var sidebar = document.getElementById("sellOnFloraSideBar");
  if (sidebar) {
    sidebar.style.width = "0"; ""
  } else {
    console.error("Sidebar element not found.");
  }
});

defineEventListener('sellOnFloraSidebar.toggleDropdown', function toggleDropdown(optionId) {
  const dropdown = document.getElementById(optionId);
  const selectSelected = dropdown.previousElementSibling;

  dropdown.classList.toggle('select-hide');
  selectSelected.classList.toggle("open");
  if (!dropdown.classList.contains('select-hide')) {
    selectSelected.style.borderColor = '#0A3223'; // Focus color
  } else {
    selectSelected.style.borderColor = '#E6E6E6'; // Default color
  }
});

defineEventListener('sellOnFloraSidebar.handleCheckboxChange', function handleCheckboxChange(event) {
  event.stopPropagation();
  const optionValue = event.target.value;
  const isChecked = event.target.checked;
  const customSelect = event.target.closest('.custom-select');
  const containerId = customSelect.querySelector('.chip-container').id;
  const inputContainer = customSelect.querySelector('.input-container');

  if (isChecked) {
    createChip(containerId, event.target.nextSibling.textContent.trim(), optionValue);
    if (optionValue === 'other') {
      inputContainer.style.display = 'block';
    }
  } else {
    const chipToRemove = document.getElementById(containerId).querySelector(`div[data-value='${optionValue}']`);
    if (chipToRemove) {
      chipToRemove.remove();
    }
    if (optionValue === 'other') {
      inputContainer.style.display = 'none';
    }
  }
});

defineEventListener('sellOnFloraSidebar.addCustomOption', function addCustomOption(containerId, inputContainer) {
  const inputField = inputContainer.querySelector('input');
  const label = inputContainer.querySelector('.input-label');

  if (inputField.value.trim() !== "") {
    createChip(containerId, inputField.value, 'custom');
    inputField.value = "";
  }

  inputContainer.style.display = 'none'; // Hide input container after processing
});

function createChip(containerId, text, value) {
  const container = document.getElementById(containerId);
  const chip = document.createElement('div');
  chip.className = 'chip';
  chip.textContent = text;
  chip.setAttribute('data-value', value);

  const closeBtn = document.createElement('span');
  closeBtn.textContent = '×';
  closeBtn.className = 'close-chip';
  closeBtn.onclick = () => {
    container.removeChild(chip);
    const customSelect = container.closest('.custom-select');

    const correspondingCheckbox = customSelect.querySelector(`input[type="checkbox"][value="${value}"]`);
    if (correspondingCheckbox) {
      correspondingCheckbox.checked = false;
    }

    if (value === 'other') {
      const inputContainer = container.closest('.custom-select').querySelector('.input-container');
      inputContainer.style.display = 'none';
      const otherCheckbox = container.closest('.custom-select').querySelector('input[value="other"]');
      if (otherCheckbox) {
        otherCheckbox.checked = false;
      }
    }
  };

  chip.appendChild(closeBtn);
  container.appendChild(chip);
}

defineEventListener('sellOnFloraSidebar.submitForm', function submitForm(event) {
  event.preventDefault();

  if (!validateCurrentStep(3)) {
    return;
  }

  const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSf0vQOX5iJayR6YOE4omyv5_UfC1gTCG3bgOV7BaAaLWEHyNg/formResponse';

  const formData = new FormData();

  formData.append('entry.602890204', document.getElementById('email').value); // Email
  formData.append('entry.2134345269', document.getElementById('website').value); // Website
  formData.append('entry.557896437', document.getElementById('brandName').value); // Brand Name
  formData.append('entry.1186567875', document.getElementById('instagram').value); // Instagram Account
  formData.append('entry.1551851196', document.getElementById('contactName').value); // Contact Name
  formData.append('entry.1394358925', document.getElementById('contactPhone').value); // Contact Phone

  const ecoFriendlyOptions = getChipValues('ecoFriendlyChips').join(', ');
  formData.append('entry.778755791', ecoFriendlyOptions); // Eco-friendly Options

  formData.append('entry.184597823', getChipValues('marketChips').join(', ')); // Markets
  formData.append('entry.1716395835', document.querySelector('input[name="fulfillment"]:checked').value); // Fulfillment
  formData.append('entry.1451244347', document.querySelector('input[name="3pl"]:checked').value); // 3pl
  formData.append('entry.1155238544', document.getElementById('agreement').checked ? 'Yes' : 'No'); // Agreement
  const platformInput = document.querySelector('input[name="platform"]:checked');
  let platformValue;
  if (platformInput.value === 'Other') {
    platformValue = document.getElementById('otherPlatformInput').value;
  } else {
    platformValue = platformInput.value;
  }
  formData.append('entry.1231134045', platformValue);


  fetch(googleFormUrl, {
    method: 'POST',
    body: formData,
    mode: 'no-cors'
  })
    .then(() => {
      nextStep(4);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
});

defineEventListener('sellOnFloraSidebar.openSellOnFloraSideBar', function openSellOnFloraSideBar() {
  console.log("opening");
  var sidebar = document.getElementById("sellOnFloraSideBar");
  if (sidebar) {
    if (window.innerWidth < 519) {
      console.log("smaller")
      sidebar.style.width = window.innerWidth + "px";
    } else {
      sidebar.style.width = "519px"; // Set the width to 519px if the screen width is larger
    }
  } else {
    console.error("Sidebar element not found.");
  }
});

function getChipValues(containerId) {
  const container = document.getElementById(containerId);
  return Array.from(container.children).map(chip => {
    const chipText = chip.textContent.replace('×', '').trim();

    if (chipText.toLowerCase() === 'other') {
      const inputContainer = container.closest('.custom-select').querySelector('.input-container');
      const inputField = inputContainer.querySelector('input');
      return inputField.value.trim() || 'Other';
    }

    return chipText;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const slideshowCarousel = document.querySelector('slideshow-carousel');

  defineEventListener('slideshow.prev', () => {
    slideshowCarousel.dispatchEvent(new Event('control:prev'))
  });
  defineEventListener('slideshow.next', () => {
    slideshowCarousel.dispatchEvent(new Event('control:next'))
  });

  } catch(e) { console.error(e); }
})();
})();
